import React from 'react';
import * as ReactDOMClient from "react-dom/client";
import App from './App';

import reactToWebComponent from "react-to-webcomponent";

const WcConfigurator = reactToWebComponent(App, React, ReactDOMClient);

customElements.define("web-configurator", WcConfigurator);